import { useContext } from "react";
import { FormContextMA } from "../form-context";
import { DataField, Divider, H2, Section } from "./common-components";
import { GetDropDownValue, GetMultiDropDownValue } from "./data";
import { alcoholEnum, caffeineEnum, dietEnum, exerciseEnum, exerciseTypeEnum, recreationalDrugsEnum, smokingEnum } from "../../patient/clinical-services/service-steps/clinical-assessment/data";
import { calculateAgeYear } from "../../../helpers/functions";

export const LifestyleFactors = ({formType, clinicalAssessment, patient: patientProp}) => {
  const context = useContext(FormContextMA);
  const contextPatient = context && context.patient;
  const patient = patientProp || contextPatient;
  
  // Check if patient is less than 12 years old
  const isUnder12 = patient?.dateOfBirth && calculateAgeYear(patient.dateOfBirth) < 12;

  const formatLifestyleComments = (value) =>
    value == null ? "None" : typeof value === "string" ? value.trim() || "None" : String(value);
  
  // Helper function to check if value should show "Not Assessed"
  const getDisplayValue = (value) => {
    if (value === "Not Assessed") {
      return "Not Assessed";
    }
    if (value === undefined || value === null || value === "" || value === "undefined" || value === "n/a") {
      return "Not Assessed";
    }
    return value;
  };

  const alcoholValue = GetDropDownValue(alcoholEnum.options, clinicalAssessment?.alcohol, true);
  const caffeineValue = GetDropDownValue(caffeineEnum.options, clinicalAssessment?.caffeine);
  const smokingValue = GetDropDownValue(smokingEnum.options, clinicalAssessment?.smoking, true);
  const recreationalDrugsValue = GetMultiDropDownValue(recreationalDrugsEnum.options, clinicalAssessment?.recreationalDrugs?.join(", "));
  const dietValue = GetMultiDropDownValue(dietEnum.options, clinicalAssessment?.diet?.join(", "));
  const exerciseValue = clinicalAssessment?.exercise
    ? GetDropDownValue(exerciseEnum.options, clinicalAssessment.exercise) +
      (clinicalAssessment?.exercise !== "Not Assessed" && clinicalAssessment?.exerciseTypes?.length > 0
        ? " (" + GetMultiDropDownValue(exerciseTypeEnum.options, clinicalAssessment?.exerciseTypes?.join(", ")) + ")"
        : "")
    : "n/a";

  return (
    <Section className="space-y-[0.0833333in]" formType = {formType}>
      <H2>
        Lifestyle Factors
        {isUnder12 && " - Not Addressed due to age less than 12 years of age"}
      </H2>
      {!isUnder12 && (
        <>
          <div className="grid grid-cols-2">
            <DataField label="Alcohol Intake" value={getDisplayValue(alcoholValue)} />
            <DataField label="Caffeine Intake" value={getDisplayValue(caffeineValue)} />
          </div>
          <div className="grid grid-cols-2">
            <DataField label="Smoking" value={getDisplayValue(smokingValue)} />
            <DataField label="Recreational Drugs" value={getDisplayValue(recreationalDrugsValue)} />
          </div>
          <div className="grid grid-cols-2">
            <DataField label="Diet" value={getDisplayValue(dietValue)} />
            <DataField label="Exercise" value={getDisplayValue(exerciseValue)} />
          </div>
          <Divider />
          <DataField
            label="Lifestyle Comments"
            value={formatLifestyleComments(clinicalAssessment?.lifestyle)}
          />
        </>
      )}
    </Section>
  );
};
